import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { permissionCheck } from '../../../../app/helper-functions/PermissionCheck';
import { DrawerComponent, MenuComponent, ScrollComponent, ToggleComponent } from '../../../assets/ts/components';
import { useNavigate } from 'react-router-dom';
let attendance_type_add, attendance_type_view, attendance_type_logs;
let bank_account_type_add, bank_account_type_view, bank_account_type_logs;
let country_add, country_view, country_logs;
let city_add, city_view, city_logs;
let currency_add,currency_view, currency_logs;
let department_add,department_view,department_logs;
let education_level_add,education_level_view,education_level_logs;
let designation_add, designation_view,designation_logs;
let employment_statuses_add,employment_statuses_view,employment_statuses_logs;
let holiday_type_add,holiday_type_view,holiday_type_logs;
let gender_add, gender_view, gender_logs;
let industry_add,industry_view,industry_logs;
let job_title_add,job_title_view,job_title_logs;
let job_category_add,job_category_view,job_category_logs;
let location_add,location_view,location_logs;
let language_competencies_add,language_competencies_view,language_competencies_logs;
let leave_type_add,leave_type_view, leave_type_logs;
let pay_grade_add, pay_grade_view, pay_grade_logs;
let language_add,language_view, language_logs;
let language_fluencies_add,language_fluencies_view, language_fluencies_logs;
let license_types_add,license_types_view, license_types_logs;
let nationality_add,nationality_view, nationality_logs;
let marital_status_add,marital_status_view, marital_status_logs;
let offboarding_checklist_add,offboarding_checklist_view, offboarding_checklist_logs;
let passport_issuer_add,passport_issuer_view, passport_issuer_logs;
let exit_questionnaire_add,exit_questionnaire_view, exit_questionnaire_logs;
let reason_for_leaving_add,reason_for_leaving_view, reason_for_leaving_logs;
let reporting_method_add,reporting_method_view, reporting_method_logs;
let relationship_add,relationship_view, relationship_logs;
let source_of_hire_add,source_of_hire_view, source_of_hire_logs;
let shift_add,shift_view, shift_logs;
let exit_checklist_add,exit_checklist_view, exit_checklist_logs;
let visa_issuer_add,visa_issuer_view, visa_issuer_logs;
let type_of_asset_add,type_of_asset_view, type_of_asset_logs;
let skill_level_add,skill_level_view, skill_level_logs;
let salary_component_add,salary_component_view, salary_component_logs;
let calendar_setting_add,calendar_setting_view, calendar_setting_logs;
function SettingAside() {
  const navigate=useNavigate();
  useEffect(() => {
    navigate("/hr/settings/attendance-type/add-attendance-type")
  }, [])
  const intl = useIntl()
  city_add = permissionCheck('city-create')
    city_view = permissionCheck('city-view')
    city_logs = permissionCheck('city-activity-log')
    country_add = permissionCheck('country-create')
    country_view = permissionCheck('country-view')
    country_logs = permissionCheck('country-activity-log')
    attendance_type_add = permissionCheck('attendancetype-create')
    attendance_type_view = permissionCheck('attendancetype-view')
    attendance_type_logs = permissionCheck('attendancetype-activity-log')
    bank_account_type_add = permissionCheck('bankaccounttype-create')
    bank_account_type_view = permissionCheck('bankaccounttype-view')
    bank_account_type_logs = permissionCheck('bankaccounttype-activity-log')
    currency_add = permissionCheck('currency-create')
    currency_view = permissionCheck('currency-view')
    currency_logs = permissionCheck('currency-activity-log')
    department_add = permissionCheck('department-create')
    department_view = permissionCheck('department-view')
    department_logs = permissionCheck('department-activity-log')
    designation_add = permissionCheck('designation-create')
    designation_view = permissionCheck('designation-view')
    designation_logs = permissionCheck('designation-activity-log')
    employment_statuses_add = permissionCheck('employeestatus-create')
    employment_statuses_view = permissionCheck('employeestatus-view')
    employment_statuses_logs = permissionCheck('employeestatus-activity-log')
    education_level_add = permissionCheck('educationlevels-create')
    education_level_view = permissionCheck('educationlevels-view')
    education_level_logs = permissionCheck('educationlevels-activity-log')
    gender_add = permissionCheck('gender-create')
    gender_view = permissionCheck('gender-view')
    gender_logs = permissionCheck('gender-activity-log')
    calendar_setting_add = permissionCheck('calendar-create')
    calendar_setting_view = permissionCheck('calendar-view')
    calendar_setting_logs = permissionCheck('calendar-activity-log')
    holiday_type_add = permissionCheck('holidaytype-create')
    holiday_type_view = permissionCheck('holidaytype-view')
    holiday_type_logs = permissionCheck('holidaytype-activity-log')
    industry_add = permissionCheck('industry-create')
    industry_view = permissionCheck('industry-view')
    industry_logs = permissionCheck('industry-activity-log')
    job_title_add = permissionCheck('jobtitles-create')
    job_title_view = permissionCheck('jobtitles-view')
    job_title_logs = permissionCheck('jobtitles-activity-log')
    job_category_add = permissionCheck('jobcategories-create')
    job_category_view = permissionCheck('jobcategories-view')
    job_category_logs = permissionCheck('jobcategories-activity-log')
    location_add = permissionCheck('locations-create')
    location_view = permissionCheck('locations-view')
    location_logs = permissionCheck('locations-activity-log')
    language_competencies_add = permissionCheck('languagecompetencies-create')
    language_competencies_view = permissionCheck('languagecompetencies-view')
    language_competencies_logs = permissionCheck('languagecompetencies-activity-log')
    leave_type_add = permissionCheck('leavetypes-create')
    leave_type_view = permissionCheck('leavetypes-view')
    leave_type_logs = permissionCheck('leavetypes-activity-log')
    language_add = permissionCheck('languages-create')
    language_view = permissionCheck('languages-view')
    language_logs = permissionCheck('languages-activity-log')
    language_fluencies_add = permissionCheck('languagefluencies-create')
    language_fluencies_view = permissionCheck('languagefluencies-view')
    language_fluencies_logs = permissionCheck('languagefluencies-activity-log')
    license_types_add = permissionCheck('licensetypes-create')
    license_types_view = permissionCheck('licensetypes-view')
    license_types_logs = permissionCheck('licensetypes-activity-log')
    marital_status_add = permissionCheck('martialstatus-create')
    marital_status_view = permissionCheck('martialstatus-view')
    marital_status_logs = permissionCheck('martialstatus-activity-log')
    nationality_add = permissionCheck('nationality-create')
    nationality_view = permissionCheck('nationality-view')
    nationality_logs = permissionCheck('nationality-activity-log')
    offboarding_checklist_add = permissionCheck('offboardingchecklist-create')
    offboarding_checklist_view = permissionCheck('offboardingchecklist-view')
    offboarding_checklist_logs = permissionCheck('offboardingchecklist-activity-log')
    pay_grade_add = permissionCheck('paygrade-create')
    pay_grade_view = permissionCheck('paygrade-view')
    pay_grade_logs = permissionCheck('paygrade-activity-log')
    passport_issuer_add = permissionCheck('passportissuer-create')
    passport_issuer_view = permissionCheck('passportissuer-view')
    passport_issuer_logs = permissionCheck('passportissuer-activity-log')
    exit_questionnaire_add = permissionCheck('questionnaireforexit-create')
    exit_questionnaire_view = permissionCheck('questionnaireforexit-view')
    exit_questionnaire_logs = permissionCheck('questionnaireforexit-activity-log')
    reason_for_leaving_add = permissionCheck('reasonforleaving-create')
    reason_for_leaving_view = permissionCheck('reasonforleaving-view')
    reason_for_leaving_logs = permissionCheck('reasonforleaving-activity-log')
    reporting_method_add = permissionCheck('reportingmethod-create')
    reporting_method_view = permissionCheck('reportingmethod-view')
    reporting_method_logs = permissionCheck('reportingmethod-activity-log')
    relationship_add = permissionCheck('relationship-create')
    relationship_view = permissionCheck('relationship-view')
    relationship_logs = permissionCheck('relationship-activity-log')
    source_of_hire_add = permissionCheck('sourceofhire-create')
    source_of_hire_view = permissionCheck('sourceofhire-view')
    source_of_hire_logs = permissionCheck('sourceofhire-activity-log')
    shift_add = permissionCheck('shiftdepartment-create')
    shift_view = permissionCheck('shiftdepartment-view')
    shift_logs = permissionCheck('shiftdepartment-activity-log')
    salary_component_add = permissionCheck('salarycomponent-create')
    salary_component_view = permissionCheck('salarycomponent-view')
    salary_component_logs = permissionCheck('salarycomponent-activity-log')
    skill_level_add = permissionCheck('skilllevel-create')
    skill_level_view = permissionCheck('skilllevel-view')
    skill_level_logs = permissionCheck('skilllevel-activity-log')
    type_of_asset_add = permissionCheck('typeofasset-create')
    type_of_asset_view = permissionCheck('typeofasset-view')
    type_of_asset_logs = permissionCheck('typeofasset-activity-log')
    visa_issuer_add = permissionCheck('visaissuer-create')
    visa_issuer_view = permissionCheck('visaissuer-view')
    visa_issuer_logs = permissionCheck('visaissuer-activity-log')
    exit_checklist_add = permissionCheck('employeeexitchecklistanswer-create')
    exit_checklist_view = permissionCheck('employeeexitchecklistanswer-view')
    exit_checklist_logs = permissionCheck('employeeexitchecklistanswer-activity-log')
  return (
    <>
      {/* Settings */}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Settings</span>
        </div>
      </div>
      {attendance_type_add || attendance_type_logs || attendance_type_view ?(
      <AsideMenuItemWithSub
        to='/hr/settings/attendance-type'
        title='Attendance Types'
        fontIcon='bi-archive'
        icon='fa fa-clipboard-user'
      >
    {attendance_type_add&& (<AsideMenuItem to='/hr/settings/attendance-type/add-attendance-type' title='Add Attendance Type' hasBullet={true} />)}
    {attendance_type_view&&    (<AsideMenuItem to='/hr/settings/attendance-type/attendance-type-list' title='List of All Attendance Types' hasBullet={true} />)}
    {attendance_type_logs&& (<AsideMenuItem to='/hr/settings/attendance-type/all-attendance-type-logs' title='Logs of All Attendance Types' hasBullet={true} />)}
      </AsideMenuItemWithSub>
):null}
  {bank_account_type_add || bank_account_type_logs || bank_account_type_view ?(
      <AsideMenuItemWithSub
        to='/hr/settings/bank-account-types'
        title='Bank Account Types'
        fontIcon='bi-archive'
        icon='fa fa-building-columns'
      >
 {bank_account_type_add&& (<AsideMenuItem to='/hr/settings/bank-account-types/add-bank-account-type' title='Add Bank Account Type' hasBullet={true} />)}
   {bank_account_type_view &&( <AsideMenuItem to='/hr/settings/bank-account-types/bank-account-types-list' title='List of Bank Account Types' hasBullet={true} />)}
     {bank_account_type_logs&&(<AsideMenuItem to='/hr/settings/bank-account-types/all-bank-account-types-logs' title='Logs of All Bank Account Types' hasBullet={true} />)}
      </AsideMenuItemWithSub>
  ):null}
  {
        calendar_setting_add || calendar_setting_view || calendar_setting_logs ? (
          <AsideMenuItemWithSub
          to='/hr/settings/calendar-settings'
          title='Calendar Settings'
          fontIcon='bi-archive'
          icon='fa fa-calendar'
        >
            {
              calendar_setting_add && (
                <AsideMenuItem to='/hr/settings/calendar-settings/add-calendar-settings' title='Add Calendar Settings' hasBullet={true} />
              )
            }
            {
              calendar_setting_logs && (
                <AsideMenuItem to='/hr/settings/calendar-settings/all-calendar-settings-logs' title='Logs of All Calendar Settings' hasBullet={true} />
              )
            }
        </AsideMenuItemWithSub>
        ):null}
           {country_add || country_logs|| country_view ?(
      <AsideMenuItemWithSub
        to='/hr/settings/countries'
        title='Countries'
        fontIcon='bi-archive'
        icon='fa fa-earth-americas'
      >
      {country_add &&(  <AsideMenuItem to='/hr/settings/countries/add-country' title='Add Country' hasBullet={true} />)}
        {country_view &&(<AsideMenuItem to='/hr/settings/countries/countries-list' title='List of Countries' hasBullet={true} />)}
       {country_logs &&( <AsideMenuItem to='/hr/settings/countries/all-countries-logs' title='Logs of All Countries' hasBullet={true} />)}
      </AsideMenuItemWithSub>
   ):null}
    {city_add || city_logs|| city_view ?(
   <AsideMenuItemWithSub
   to='/hr/settings/cities'
   title='Cities'
   fontIcon='bi-archive'
   icon='fa fa-city'
 >
  {city_add&&(<AsideMenuItem to='/hr/settings/cities/add-city' title='Add City' hasBullet={true} />)} 
  {city_view&&(<AsideMenuItem to='/hr/settings/cities/cities-list' title='List of Cities' hasBullet={true} />)} 
  {city_logs&&(<AsideMenuItem to='/hr/settings/cities/all-cities-logs' title='Logs of All Cities' hasBullet={true} />)} 
 </AsideMenuItemWithSub>
     ):null}
      {currency_add || currency_logs|| currency_view ?(
  <AsideMenuItemWithSub
  to='/hr/settings/currencies'
  title='Currencies'
  fontIcon='bi-archive'
  icon='some-files'
>
 {currency_add&&(<AsideMenuItem to='/hr/settings/currencies/add-currency' title='Add Currency' hasBullet={true} />)} 
 {currency_view&&(<AsideMenuItem to='/hr/settings/currencies/currencies-list' title='List of Currencies' hasBullet={true} />)} 
 {currency_logs&&(<AsideMenuItem to='/hr/settings/currencies/all-currencies-logs' title='Logs of All Currencies' hasBullet={true} />)} 
</AsideMenuItemWithSub>
      ):null}
      {department_add|| department_logs|| department_view?(
   <AsideMenuItemWithSub
   to='/hr/settings/department'
   title='Departments'
   fontIcon='bi-archive'
   icon='abstract-19'
 >
  {
    department_add && (
      <AsideMenuItem to='/hr/settings/department/add-department' title='Add Department' hasBullet={true} />
    )
  }
   {
    department_view && (
      <AsideMenuItem to='/hr/settings/department/department-list' title='List of Departments' hasBullet={true} />
    )
   }
   {
    department_logs && (
      <AsideMenuItem to='/hr/settings/department/all-department-logs' title='Logs of All Departments' hasBullet={true} />
    )
   }
 </AsideMenuItemWithSub>
      ):null}
        {designation_add|| designation_logs|| designation_view?(
   <AsideMenuItemWithSub
   to='/hr/settings/designations'
   title='Designations'
   fontIcon='bi-archive'
   icon='abstract-26'
 >
   {
    designation_add &&(
      <AsideMenuItem to='/hr/settings/designations/add-designation' title='Add Designation' hasBullet={true} />
    )
   }
   {
    designation_view && (
      <AsideMenuItem to='/hr/settings/designations/designations-list' title='List of Designations' hasBullet={true} />
    )
   }
   {
    designation_logs && (
      <AsideMenuItem to='/hr/settings/designations/all-designations-logs' title='Logs of All Designations' hasBullet={true} />
    )
   }
 </AsideMenuItemWithSub>
        ):null}
              {education_level_add||education_level_logs|| education_level_view?(
     <AsideMenuItemWithSub
     to='/hr/settings/education-level'
     title='Education Level'
     fontIcon='bi-archive'
     icon='fa fa-building-columns'
   >
    {
      education_level_add &&(
        <AsideMenuItem to='/hr/settings/education-level/add-education-level' title='Add Education Level' hasBullet={true} />
      )
    }
     {
      education_level_view && (
<AsideMenuItem to='/hr/settings/education-level/education-level-list' title='List of Education Level' hasBullet={true} />
      )
     }
     {
      education_level_logs && (
        <AsideMenuItem to='/hr/settings/education-level/all-education-level-logs' title='Logs of All Education Level' hasBullet={true} />
      )
     }
   </AsideMenuItemWithSub>
       ):null}
       {employment_statuses_add||employment_statuses_logs|| employment_statuses_view?(
     <AsideMenuItemWithSub
     to='/hr/settings/employment-statuses'
     title='Employment Statuses'
     fontIcon='bi-archive'
     icon='fa fa-address-card'
   >
    {
      employment_statuses_add && (
<AsideMenuItem to='/hr/settings/employment-statuses/add-employment-statuses' title='Add Employment Statuses' hasBullet={true} />
      )
    }
     {
      employment_statuses_view && (
<AsideMenuItem to='/hr/settings/employment-statuses/employment-statuses-list' title='List of Employment Statuses' hasBullet={true} />
      )
     }
     {
      employment_statuses_logs && (
        <AsideMenuItem to='/hr/settings/employment-statuses/all-employment-statuses-logs' title='Logs of All Employment Statuses' hasBullet={true} />
      )
     }
   </AsideMenuItemWithSub>
       ):null}
        {
        exit_checklist_add || exit_checklist_logs || exit_checklist_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/checklist-exit-interview'
          title='Exit Checklist'
          fontIcon='bi-archive'
          icon='fa fa-right-from-bracket'
        >
          {
            exit_checklist_add && (
              <AsideMenuItem to='/hr/settings/checklist-exit-interview/add-checklist-exit-interview' title='Add Exit Checklist' hasBullet={true} />
            )
          }
          {
            exit_checklist_view && (
              <AsideMenuItem to='/hr/settings/checklist-exit-interview/checklist-exit-interview-list' title='List of Exit Checklist' hasBullet={true} />
            )
          }
          {
            exit_checklist_logs && (
              <AsideMenuItem to='/hr/settings/checklist-exit-interview/all-checklist-exit-interview-logs' title='Logs of All Exit Checklist' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
      }   {
        exit_questionnaire_add || exit_questionnaire_logs || exit_questionnaire_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/questionnaire'
          title='Exit Questionnaire'
          fontIcon='bi-archive'
          icon='fa fa-person-circle-question'
        >
          {
            exit_questionnaire_add && (
              <AsideMenuItem to='/hr/settings/questionnaire/add-questionnaire' title='Add Exit Questionnaire' hasBullet={true} />
            )
          }
          {
            exit_questionnaire_view && (
              <AsideMenuItem to='/hr/settings/questionnaire/questionnaire-list' title='List of Exit Questionnaire' hasBullet={true} />
            )
          }
          {
            exit_questionnaire_logs && (
              <AsideMenuItem to='/hr/settings/questionnaire/all-questionnaire-logs' title='Logs of All Exit Questionnaire' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
      }
      {
        gender_add || gender_view || gender_logs ? (
          <AsideMenuItemWithSub
            to='/hr/settings/gender'
            title='Genders'
            fontIcon='bi-archive'
            icon='abstract-38'
          >
            {
              gender_add && (
                <AsideMenuItem to='/hr/settings/gender/add-gender' title='Add Gender' hasBullet={true} />
              )
            }
            {
              gender_view && (
                <        AsideMenuItem to='/hr/settings/gender/gender-list' title='List of Genders' hasBullet={true} />
              )
            }

            {
              gender_logs && (
                <AsideMenuItem to='/hr/settings/gender/all-gender-logs' title='Logs of All Genders' hasBullet={true} />
              )
            }
          </AsideMenuItemWithSub>
        ) : null
      }
      {
        holiday_type_add || holiday_type_view || holiday_type_logs ? (
          <AsideMenuItemWithSub
            to='/hr/settings/holiday-types'
            title='Holiday Types'
            fontIcon='bi-archive'
            icon='fa fa-calendar'
          >
            {
              holiday_type_add && (
                <AsideMenuItem to='/hr/settings/holiday-types/add-holiday-type' title='Add Holiday Type' hasBullet={true} />
              )
            }
            {
              holiday_type_view && (
                <AsideMenuItem to='/hr/settings/holiday-types/holiday-types-list' title='List of Holiday Types' hasBullet={true} />
              )
            }
            {
              holiday_type_logs && (
                <AsideMenuItem to='/hr/settings/holiday-types/all-holiday-types-logs' title='Logs of All Holiday Types' hasBullet={true} />
              )
            }
          </AsideMenuItemWithSub>
        ) : null
      }
      {
        industry_add || industry_view || industry_logs ? (
          <AsideMenuItemWithSub
            to='/hr/settings/industries'
            title='Industries'
            fontIcon='bi-archive'
            icon='fa fa-industry'
          >
            {
              industry_add && (
                <AsideMenuItem to='/hr/settings/industries/add-industries' title='Add Industries' hasBullet={true} />
              )
            }
            {
              industry_view && (
                <AsideMenuItem to='/hr/settings/industries/industries-list' title='List of Industries' hasBullet={true} />
              )
            }
            {
              industry_logs && (
                <AsideMenuItem to='/hr/settings/industries/all-industries-logs' title='Logs of All Industries' hasBullet={true} />
              )
            }
          </AsideMenuItemWithSub>
        ) : null
      }
     {
      job_category_add || job_category_logs || job_category_view ?(
        <AsideMenuItemWithSub
        to='/hr/settings/job-categories'
        title='Job Categories'
        fontIcon='bi-archive'
        icon='fa fa-list-alt'
      >
        {
          job_category_add && (
            <AsideMenuItem to='/hr/settings/job-categories/add-job-category' title='Add Job Category' hasBullet={true} />
          )
        }
        {
          job_category_view && (
            <AsideMenuItem to='/hr/settings/job-categories/job-categories-list' title='List of Job Categories' hasBullet={true} />
          )
        }
       {
        job_category_logs && (
          <AsideMenuItem to='/hr/settings/job-categories/all-job-categories-logs' title='Logs of All Job Ctaregories' hasBullet={true} />
        )
       }
      </AsideMenuItemWithSub>
      ):null
     }
      {
        job_title_add || job_title_logs || job_title_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/job-title'
          title='Job Title'
          fontIcon='bi-archive'
          icon='fa fa-briefcase'
        >
          {
            job_title_add && (
              <AsideMenuItem to='/hr/settings/job-title/add-job-title' title='Add Job Title' hasBullet={true} />
            )
          }
          {
            job_title_view && (
              <AsideMenuItem to='/hr/settings/job-title/job-title-list' title='List of Job Title' hasBullet={true} />
            )
          }
          {
            job_title_logs && (
              <AsideMenuItem to='/hr/settings/job-title/all-job-title-logs' title='Logs of All Job Titles' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
      }
       {
      language_competencies_add || language_competencies_logs || language_competencies_view ? (
        <AsideMenuItemWithSub
        to='/hr/settings/language-competencies'
        title='Language Competencies'
        fontIcon='bi-archive'
        icon='abstract-31'
      >
        {
          language_competencies_add && (
            <AsideMenuItem to='/hr/settings/language-competencies/add-language-competencies' title='Add Language Competencies' hasBullet={true} />
          )
        }
          {
          language_competencies_view && (
            <AsideMenuItem to='/hr/settings/language-competencies/language-competencies-list' title='List of Language Competencies' hasBullet={true} />
          )
        }
        {
          language_competencies_logs && (
            <AsideMenuItem to='/hr/settings/language-competencies/all-language-competencies-logs' title='Logs of All Language Competencies' hasBullet={true} />
          )
        }
      </AsideMenuItemWithSub>
      ):null
      }
         {
        language_fluencies_add || language_fluencies_logs || language_fluencies_view ? (
          <AsideMenuItemWithSub
        to='/hr/settings/language-fluencies'
        title='Language Fluencies'
        fontIcon='bi-archive'
        icon='abstract-22'
      >
        {
          language_fluencies_add && (
            <AsideMenuItem to='/hr/settings/language-fluencies/add-language-fluencies' title='Add Language Fluencies' hasBullet={true} />
          )
        }
        {
          language_fluencies_view && (
            <AsideMenuItem to='/hr/settings/language-fluencies/language-fluencies-list' title='List of Language Fluencies' hasBullet={true} />
          )
        }
       {
        language_fluencies_logs && (
          <AsideMenuItem to='/hr/settings/language-fluencies/all-language-fluencies-logs' title='Logs of All Language Fluencies' hasBullet={true} />
        )
       }
      </AsideMenuItemWithSub>
        ):null
      }
        {
      language_add || language_logs || language_view ? (
        <AsideMenuItemWithSub
        to='/hr/settings/languages'
        title='Languages'
        fontIcon='bi-archive'
        icon='fa fa-language'
      >
        {
          language_add  && (
            <AsideMenuItem to='/hr/settings/languages/add-language' title='Add Languages' hasBullet={true} />
          )
        }
        {
          language_view && (
            <AsideMenuItem to='/hr/settings/languages/languages-list' title='List of Languages' hasBullet={true} />
          )
        }
        {
          language_logs && (
            <AsideMenuItem to='/hr/settings/languages/all-languages-logs' title='Logs of All Languages' hasBullet={true} />
          )
        }
      </AsideMenuItemWithSub>
      ):null
    }
      
      {/* {
        leave_type_add || leave_type_logs || leave_type_view ? (
          <AsideMenuItemWithSub
            to='/hr/settings/leave-types'
            title='Leave Types'
            fontIcon='bi-archive'
            icon='abstract-37'
          >
            {
              leave_type_add && (
                <AsideMenuItem to='/hr/settings/leave-types/add-leave-type' title='Add Leave Type' hasBullet={true} />
              )
            }
            {
              leave_type_view && (
                <AsideMenuItem to='/hr/settings/leave-types/leave-types-list' title='List of Leave Types' hasBullet={true} />
              )
            }
            {
              leave_type_logs && (
                <AsideMenuItem to='/hr/settings/leave-types/all-leave-types-logs' title='Logs of All Leave Types' hasBullet={true} />
              )
            }
          </AsideMenuItemWithSub>
        ) : null
      } */}
     {
      license_types_add || license_types_logs || license_types_view ? (
        <AsideMenuItemWithSub
        to='/hr/settings/license-types'
        title='License Types'
        fontIcon='bi-archive'
        icon='fa fa-id-card'
      >
        {
          license_types_add && (
            <AsideMenuItem to='/hr/settings/license-types/add-license-type' title='Add License Type' hasBullet={true} />
          )
        }
        {
          license_types_view && (
            <AsideMenuItem to='/hr/settings/license-types/license-types-list' title='List of License Types' hasBullet={true} />
          )
        }
        {
          license_types_logs && (
            <AsideMenuItem to='/hr/settings/license-types/all-license-types-logs' title='Logs of All License Types' hasBullet={true} />
          )
        }
      </AsideMenuItemWithSub>
      ):null
     }
   {
    location_add || location_logs || location_logs ? (
      <AsideMenuItemWithSub
      to='/hr/settings/location'
      title='Locations'
      fontIcon='bi-archive'
      icon='geolocation'
    >
      {
        location_add && (
          <AsideMenuItem to='/hr/settings/location/add-location' title='Add Location' hasBullet={true} />
        )
      }
      {
        location_view && (
          <AsideMenuItem to='/hr/settings/location/location-list' title='List of Location' hasBullet={true} />
        )
      }
        {
          location_logs && (
            <AsideMenuItem to='/hr/settings/location/all-location-logs' title='Logs of All locations' hasBullet={true} />
          )
        }
    </AsideMenuItemWithSub>
    ):null
   }
    {
      marital_status_add || marital_status_logs || marital_status_view ? (
        <AsideMenuItemWithSub
        to='/hr/settings/marital-status'
        title='Marital Status'
        fontIcon='bi-archive'
        icon='abstract-39'
      >
       {
        marital_status_add && (
          <AsideMenuItem to='/hr/settings/marital-status/add-marital-status' title='Add Marital Status' hasBullet={true} />
        )
       }
       {
        marital_status_view && (
          <AsideMenuItem to='/hr/settings/marital-status/marital-status-list' title='List of Marital Status' hasBullet={true} />
        )
       }
        {
          marital_status_logs && (
            <AsideMenuItem to='/hr/settings/marital-status/all-marital-status-logs' title='Logs of All Marital Status' hasBullet={true} />
          )
        }
      </AsideMenuItemWithSub>
      ):null
    }
    {
      nationality_add || nationality_logs || nationality_view ? (
        <AsideMenuItemWithSub
        to='/hr/settings/nationality'
        title='Nationalities'
        fontIcon='bi-archive'
        icon='abstract-4'
      >
        {
          nationality_add && (
            <AsideMenuItem to='/hr/settings/nationality/add-nationality' title='Add Nationality' hasBullet={true} />
          )
        }
        {
          nationality_view && (
            <AsideMenuItem to='/hr/settings/nationality/nationality-list' title='List of Nationality' hasBullet={true} />
          )
        }
        {
          nationality_logs && (
            <AsideMenuItem to='/hr/settings/nationality/all-nationality-logs' title='Logs of All Nationality' hasBullet={true} />
          )
        }
      </AsideMenuItemWithSub>
      ):null
    }
     {
      offboarding_checklist_add || offboarding_checklist_logs || offboarding_checklist_view ? (
        <AsideMenuItemWithSub
        to='/hr/settings/offboarding-checklist'
        title='Offboarding Checklist'
        fontIcon='bi-archive'
        icon='abstract-20'
      >
        {
          offboarding_checklist_add && (
            <AsideMenuItem to='/hr/settings/offboarding-checklist/add-offboarding-checklist' title='Add Offboarding Checklist' hasBullet={true} />
          )
        }
       {
        offboarding_checklist_view && (
          <AsideMenuItem to='/hr/settings/offboarding-checklist/offboarding-checklist-list' title='List of Offboarding Checklist' hasBullet={true} />
        )
       }
        {
          offboarding_checklist_logs && (
            <AsideMenuItem to='/hr/settings/offboarding-checklist/all-offboarding-checklist-logs' title='Logs of All Offboarding Checklist' hasBullet={true} />
          )
        }
      </AsideMenuItemWithSub>
      ):null
     }
      {
      passport_issuer_add || passport_issuer_logs || passport_issuer_view ? (
        <AsideMenuItemWithSub
        to='/hr/settings/passport-issuer'
        title='Passport Issuers'
        fontIcon='bi-archive'
        icon='fa fa-passport'
      >
        {
          passport_issuer_add && (
            <AsideMenuItem to='/hr/settings/passport-issuer/add-passport-issuer' title='Add Passport Issuer' hasBullet={true} />
          )
        }
        {
          passport_issuer_view && (
            <AsideMenuItem to='/hr/settings/passport-issuer/passport-issuer-list' title='List of Passport Issuers' hasBullet={true} />
          )
        }
        {
          passport_issuer_logs && (
            <AsideMenuItem to='/hr/settings/passport-issuer/all-passport-issuer-logs' title='Logs of All Passport Issuers' hasBullet={true} />
          )
        }
      </AsideMenuItemWithSub>
      ):null
     }
      {
        pay_grade_add || pay_grade_view || pay_grade_logs ? (
          <AsideMenuItemWithSub
          to='/hr/settings/pay-grades'
          title='Pay Grades'
          fontIcon='bi-archive'
          icon='fa fa-ranking-star'
        >
          {
            pay_grade_add && (
              <AsideMenuItem to='/hr/settings/pay-grades/add-pay-grade' title='Add Pay Grade' hasBullet={true} />
            )
          }
          {
            pay_grade_view && (
              <AsideMenuItem to='/hr/settings/pay-grades/pay-grades-list' title='List of Pay Grades' hasBullet={true} />
            )
          }
          {
            pay_grade_logs && (
              <AsideMenuItem to='/hr/settings/pay-grades/all-pay-grades-logs' title='Logs of All Pay Grades' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
      }
      {
        reason_for_leaving_add || reason_for_leaving_logs || reason_for_leaving_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/reason-for-leaving'
          title='Reason for Leaving'
          fontIcon='bi-archive'
          icon='abstract-43'
        >
          {
            reason_for_leaving_add && (
              <AsideMenuItem to='/hr/settings/reason-for-leaving/add-reason-for-leaving' title='Add Reason for Leaving' hasBullet={true} />
            )
          }
          {
            reason_for_leaving_view && (
              <AsideMenuItem to='/hr/settings/reason-for-leaving/reasons-for-leaving-list' title='List of All Reasons for Leaving' hasBullet={true} />
            )
          }
          {
            reason_for_leaving_logs && (
              <AsideMenuItem to='/hr/settings/reason-for-leaving/reason-for-leaving-logs' title='Logs of All Reason for Leaving' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
      }
      {
        relationship_add || relationship_logs || relationship_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/relationships'
          title='Relationships'
          fontIcon='bi-archive'
          icon='fa fa-link'
        >
          {
            relationship_add && (
              <AsideMenuItem to='/hr/settings/relationships/add-relationship' title='Add Relationship' hasBullet={true} />
            )
          }
          {
            relationship_view && (
              <AsideMenuItem to='/hr/settings/relationships/relationships-list' title='List of Relationships' hasBullet={true} />
            )
          }
          {
            relationship_logs && (
              <AsideMenuItem to='/hr/settings/relationships/relationship-log' title='Logs of All Relationships' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
       }
       {
        reporting_method_add || reporting_method_logs || reporting_method_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/reporting-method'
          title='Reporting Method'
          fontIcon='bi-archive'
          icon='fa fa-file'
        >
          {
            reporting_method_add && (
              <AsideMenuItem to='/hr/settings/reporting-method/add-reporting-method' title='Add Reporting Method' hasBullet={true} />
            )
          }
          {
            reporting_method_view && (
              <AsideMenuItem to='/hr/settings/reporting-method/reporting-method-list' title='List of Reporting Method' hasBullet={true} />
            )
          }
          {
            reporting_method_logs && (
              <AsideMenuItem to='/hr/settings/reporting-method/all-reporting-method-logs' title='Logs of All Reporting Method' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
       }
        {
        salary_component_add || salary_component_logs || salary_component_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/salary-components'
          title='Salary Component'
          fontIcon='bi-archive'
          icon='fa fa-wallet'
        >
          {
            salary_component_add && (
              <AsideMenuItem to='/hr/settings/salary-components/add-salary-component' title='Add Salary Component' hasBullet={true} />
            )
          }
          {
            salary_component_view && (
              <AsideMenuItem to='/hr/settings/salary-components/salary-components-list' title='List of Salary Components' hasBullet={true} />
            )
          }
          {
            salary_component_logs && (
              <AsideMenuItem to='/hr/settings/salary-components/all-salary-components-logs' title='Logs of All Salary Components' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
       }
        {
        shift_add || shift_logs || shift_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/shifts'
          title='Shifts'
          fontIcon='bi-archive'
          icon='fa fa-business-time'
        >
          {
            shift_add && (
              <AsideMenuItem to='/hr/settings/shifts/add-shift' title='Add Shift' hasBullet={true} />
            )
          }
          {
            shift_view && (
              <AsideMenuItem to='/hr/settings/shifts/shifts-list' title='List of All Shifts' hasBullet={true} />
            )
          }
          {
            shift_logs && (
              <AsideMenuItem to='/hr/settings/shifts/all-shifts-logs' title='Logs of All Shifts' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
      }
      {
        skill_level_add || skill_level_logs || skill_level_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/skill-levels'
          title='Skill Level'
          fontIcon='bi-archive'
          icon='fa fa-layer-group'
        >
          {
            skill_level_add && (
              <AsideMenuItem to='/hr/settings/skill-levels/add-skill-level' title='Add Skill Level' hasBullet={true} />
            )
          }
          {
            skill_level_view && (
              <AsideMenuItem to='/hr/settings/skill-levels/skill-levels-list' title='List of Skill Levels' hasBullet={true} />
            )
          }
          {
            skill_level_logs && (
              <AsideMenuItem to='/hr/settings/skill-levels/all-skill-levels-logs' title='Logs of All Skill Levels' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
      }
      {
        source_of_hire_add || source_of_hire_logs || source_of_hire_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/source-of-hire'
          title='Source of Hire'
          fontIcon='bi-archive'
          icon='abstract-27'
        >
          {
            source_of_hire_add && (
            <AsideMenuItem to='/hr/settings/source-of-hire/add-source-of-hire' title='Add Source of Hire' hasBullet={true} />
            )
          }
          {
            source_of_hire_view && (
              <AsideMenuItem to='/hr/settings/source-of-hire/source-of-hire-list' title='List of Source of Hire' hasBullet={true} />
            )
          }
          {
            source_of_hire_logs && (
              <AsideMenuItem to='/hr/settings/source-of-hire/all-source-of-hire-logs' title='Logs of All Source of Hire' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
      }
       {
        type_of_asset_add || type_of_asset_view ? (
          <AsideMenuItemWithSub
          to='/hr/settings/type-of-assets'
          title='Type of Assets'
          fontIcon='bi-archive'
          icon='abstract-14'
        >
          {
            type_of_asset_add && (
              <AsideMenuItem to='/hr/settings/type-of-assets/add-type-of-asset' title='Add Type of Asset' hasBullet={true} />
            )
          }
          {
            type_of_asset_view && (
              <AsideMenuItem to='/hr/settings/type-of-assets/type-of-assets-list' title='List of Type of Assets' hasBullet={true} />
            )
          }
          {
            type_of_asset_logs && (
              <AsideMenuItem to='/hr/settings/type-of-assets/all-type-of-assets-logs' title='Logs of All Type of Assets' hasBullet={true} />
            )
          }
        </AsideMenuItemWithSub>
        ):null
       }
      {
        visa_issuer_add || visa_issuer_logs || visa_issuer_view ? (
        <AsideMenuItemWithSub
        to='/hr/settings/visa-issuer'
        title='Visa Issuers'
        fontIcon='bi-archive'
        icon='fa-brands fa-cc-visa'
      >
        {
          visa_issuer_add && (
          <AsideMenuItem to='/hr/settings/visa-issuer/add-visa-issuer' title='Add Visa issuer' hasBullet={true} />
          )
        }
        {
          visa_issuer_view && (
            <AsideMenuItem to='/hr/settings/visa-issuer/visa-issuers-list' title='List of Visa Issuers' hasBullet={true} />
          )
        }
        {
          visa_issuer_logs && (
            <AsideMenuItem to='/hr/settings/visa-issuer/all-visa-issuer-logs' title='Logs of All Visa Issuers' hasBullet={true} />
          )
        }
      </AsideMenuItemWithSub>
        ):null
      }
    </>
  )
}
export default SettingAside;
